import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fNumberOneDecimal(number: InputValue) {
  return numeral(number).format('0.[0]');
}

export function fCurrency(number: InputValue) {
  if (number == null) return '';

  return numeral(number).format('$0,0.00');
}

export function fCurrencyThreeDecimals(number: InputValue) {
  if (number == null) return '';

  return numeral(number).format('$0,0.000');
}

export function fPercent(number: InputValue) {
  const format = number != null ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number != null ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number != null ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function kFormat(num?: number, precision = 1) {
  if (num == null) return null;
  return Math.abs(num) > 999999
    ? (Math.sign(num) * (Math.abs(num) / 1000000)).toFixed(precision) + 'M'
    : Math.abs(num) > 999
      ? (Math.sign(num) * (Math.abs(num) / 1000)).toFixed(precision) + 'K'
      : (Math.sign(num) * Math.abs(num)).toString();
}
